// Estimated Delivery Timeline - EuropeSnus
// Geolocation logic mirrored from component-shipping-notice.js
// Delivery times sourced directly from Shopify shipping profiles

(function () {

  // CONFIG
  const CUTOFF_HOUR  = 14;
  const IPAPI_KEY    = 'sOj1zHcxXJRzvQIbgT9zlRlH7Atr9SldtIMglvbWC1OExlIkO9';
  const MIN_TRANSIT  = 2;
  const CACHE_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

  // Danish public holidays (YYYY-MM-DD) - PostNord ingen afhentning
  // Kilde: PostNord distributionskalender 2026
  const HOLIDAYS = [
    '2025-01-01','2025-04-17','2025-04-18','2025-04-20','2025-04-21',
    '2025-05-16','2025-05-29','2025-06-05','2025-06-06','2025-12-25','2025-12-26',
    '2026-01-01','2026-04-02','2026-04-03','2026-04-05','2026-04-06', // 02 apr = Skaertorsdag tilfojet
    '2026-05-01','2026-05-14','2026-05-25','2026-06-05','2026-12-25','2026-12-26',
    '2027-01-01','2027-03-25','2027-03-26','2027-03-28','2027-03-29',
    '2027-05-06','2027-05-17','2027-06-04','2027-06-05','2027-12-24','2027-12-25','2027-12-26',
  ];

  // Delivery transit days per country (min, max) - sourced from Shopify shipping profiles
  const TRANSIT = {
    AL: [2, 4],  AT: [2, 3],  AD: [4, 7],  BE: [2, 2],  BA: [5, 10],
    BG: [4, 5],  CA: [3, 7],  HR: [4, 6],  CY: [3, 5],  CZ: [2, 3],
    DK: [2, 2],  EE: [4, 5],  FO: [2, 3],  FI: [2, 4],  FR: [2, 3],
    DE: [2, 2],  GR: [4, 7],  GL: [3, 5],  HU: [3, 5],  IS: [3, 4],
    IE: [3, 5],  IT: [3, 4],  LV: [4, 5],  LI: [3, 4],  LT: [4, 5],
    LU: [2, 3],  MT: [3, 5],  MC: [3, 4],  NL: [2, 2],  NO: [3, 5],
    PL: [4, 6],  PT: [4, 5],  RO: [3, 3],  SM: [4, 7],  RS: [3, 5],
    SK: [3, 3],  SI: [3, 4],  ES: [3, 5],  SE: [2, 4],  CH: [2, 4],
    GB: [2, 5],  US: [3, 7],
    DEFAULT: [3, 5],
  };

  // HELPERS
  function isHoliday(d) { return HOLIDAYS.includes(d.toISOString().slice(0, 10)); }
  function isWorkday(d) { var day = d.getDay(); return day !== 0 && day !== 6 && !isHoliday(d); }
  function addWorkdays(d, n) {
    var r = new Date(d), added = 0;
    while (added < n) { r.setDate(r.getDate() + 1); if (isWorkday(r)) added++; }
    return r;
  }
  function nextWorkday(d) {
    var r = new Date(d); r.setDate(r.getDate() + 1);
    while (!isWorkday(r)) r.setDate(r.getDate() + 1);
    return r;
  }
  function fmtDate(d) { return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); }
  function fmtCountdown(secs) {
    var h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60), s = secs % 60;
    if (h > 0) return h + 'h ' + String(m).padStart(2,'0') + 'm ' + String(s).padStart(2,'0') + 's';
    return m + 'm ' + String(s).padStart(2,'0') + 's';
  }

  // GEOLOCATION with 24h TTL cache
  function getCountryCode(callback) {
    try {
      var stored = localStorage.getItem('edd_country');
      if (stored) {
        var parsed = JSON.parse(stored);
        if (Date.now() - parsed.ts < CACHE_TTL_MS) {
          callback(parsed.cc.toUpperCase());
          return;
        }
      }
    } catch(e) {}
    fetch('https://ipapi.co/json/?key=' + IPAPI_KEY)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var cc = (data && data.country_code) ? data.country_code.toUpperCase() : 'DEFAULT';
        try { localStorage.setItem('edd_country', JSON.stringify({ cc: cc, ts: Date.now() })); } catch(e) {}
        callback(cc);
      })
      .catch(function() { callback('DEFAULT'); });
  }

  // CALCULATE
  function calcDates(transit) {
    var now   = new Date();
    var dnNow = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' }));
    var hour  = dnNow.getHours();
    var today = new Date(dnNow); today.setHours(0,0,0,0);

    var beforeCutoff = hour < CUTOFF_HOUR && isWorkday(dnNow);
    var ships        = beforeCutoff ? new Date(today) : nextWorkday(today);
    var minDays      = Math.max(transit[0], MIN_TRANSIT);
    var maxDays      = Math.max(transit[1], MIN_TRANSIT);
    var deliverMin   = addWorkdays(ships, minDays);
    var deliverMax   = addWorkdays(ships, maxDays);

    var secsLeft = null;
    if (beforeCutoff) {
      var cutoffToday = new Date(dnNow); cutoffToday.setHours(CUTOFF_HOUR, 0, 0, 0);
      secsLeft = Math.max(0, Math.floor((cutoffToday - dnNow) / 1000));
    }
    return { today: today, ships: ships, deliverMin: deliverMin, deliverMax: deliverMax, secsLeft: secsLeft, beforeCutoff: beforeCutoff };
  }

  // RENDER
  function render(el, countryCode) {
    var transit = TRANSIT[countryCode] || TRANSIT.DEFAULT;
    var res = calcDates(transit);
    var sameDay = res.beforeCutoff && res.ships.getTime() === res.today.getTime();

    var steps = [
      { icon: '\uD83D\uDCE6', label: 'Purchased',  date: 'Today',                                                    done: true  },
      { icon: '\u26A1',         label: 'Processing', date: sameDay ? 'Today' : fmtDate(res.ships),                    done: false },
      { icon: '\uD83D\uDE9A', label: 'Delivered',  date: res.deliverMin.getTime() === res.deliverMax.getTime() ? fmtDate(res.deliverMin) : fmtDate(res.deliverMin) + ' - ' + fmtDate(res.deliverMax), done: false },
    ];

    var urgency = res.secsLeft !== null
      ? '<div class="edd-urgency">Order within <strong id="edd-timer">' + fmtCountdown(res.secsLeft) + '</strong> for same-day shipping!</div>'
      : '<div class="edd-urgency edd-urgency--next">Order now - ships next business day</div>';

    var stepsHTML = steps.map(function(s, i) {
      return '<div class="edd-step' + (s.done ? ' edd-step--done' : '') + '">'
        + '<div class="edd-step__node"><span>' + s.icon + '</span></div>'
        + (i < steps.length - 1 ? '<div class="edd-step__connector"></div>' : '')
        + '<div class="edd-step__info"><span class="edd-step__label">' + s.label + '</span>'
        + '<span class="edd-step__date">' + s.date + '</span></div>'
        + '</div>';
    }).join('');

    el.innerHTML = '<div class="edd-widget">' + urgency + '<div class="edd-timeline">' + stepsHTML + '</div></div>';
    if (res.secsLeft !== null) startCountdown(res.secsLeft);
  }

  // COUNTDOWN
  var _timer = null;
  function startCountdown(initialSecs) {
    if (_timer) clearInterval(_timer);
    var remaining = initialSecs;
    _timer = setInterval(function() {
      remaining--;
      if (remaining <= 0) {
        clearInterval(_timer);
        document.querySelectorAll('estimated-delivery').forEach(function(el) {
          render(el, el.dataset.country || 'DEFAULT');
        });
        return;
      }
      var timerEl = document.getElementById('edd-timer');
      if (timerEl) timerEl.textContent = fmtCountdown(remaining);
    }, 1000);
  }

  // CUSTOM ELEMENT
  if (!customElements.get('estimated-delivery')) {
    customElements.define('estimated-delivery', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        self.innerHTML = '<div class="edd-widget"><div class="edd-urgency" style="text-align:center;color:#999;">Loading...</div></div>';
        getCountryCode(function(cc) {
          self.dataset.country = cc;
          render(self, cc);
          document.addEventListener('cart:updated', function() { render(self, cc); });
        });
      }
    });
  }

})();
